import { Card, Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { TfsSrpYearRateFunctionalityComponent } from "./functionalities/TfsSrpYearRateFunctionalityComponent";
import { TfsSrpYearRateModalComponent } from "./TfsSrpYearRateModalComponent";
import { TfsSrpYearRateTableComponent } from "./view/TfsSrpYearRateTableComponent";
import "../global/dataPage.css";

const { Text } = Typography;

type TfsSrpYearRateIndexComponentProps = {
  isModalOpen: boolean;
  onClickCreate: () => void;
  onClickUpdate: () => void;
  onCloseModal: () => void;
  onSaveModal: (values: any) => void;
  modalLoading: boolean;
  tfsSrpYearRatesList: any;
  onPaginationChange: any;
  searchText: string;
  onSearchChange: (value: string) => void;
  onRefresh: () => void;
  onSelectRow: any;
  selectedRowKey: any;
  selectedRow: any;
};

export const TfsSrpYearRateIndexComponent = ({
  isModalOpen,
  onClickCreate,
  onClickUpdate,
  onCloseModal,
  onSaveModal,
  modalLoading,
  tfsSrpYearRatesList,
  onPaginationChange,
  searchText,
  onSearchChange,
  onRefresh,
  onSelectRow,
  selectedRowKey,
  selectedRow,
}: TfsSrpYearRateIndexComponentProps) => {
  return (
    <>
      <Card bordered={false} className="data-page-card">
        <div className="data-page-guide">
          <QuestionCircleOutlined className="data-page-guide-icon" />
          <div>
            <Text strong className="data-page-guide-title">
              Admin Guide
            </Text>
            <Text type="secondary">
              Set the discount applied to each vehicle model year when the TFS max SRP is
              resolved. A model year without a rate leaves the SRP cap unresolved.
            </Text>
          </div>
        </div>

        <TfsSrpYearRateFunctionalityComponent
          onClickCreateTfsSrpYearRate={onClickCreate}
          onClickUpdateTfsSrpYearRate={onClickUpdate}
          onClearSelection={() => onSelectRow([], [])}
          searchText={searchText}
          onSearchChange={onSearchChange}
          onRefresh={onRefresh}
          selectedRow={selectedRow}
        />
        <TfsSrpYearRateTableComponent
          tableProps={tfsSrpYearRatesList}
          onPaginationChange={onPaginationChange}
          onSelectRow={onSelectRow}
          selectedRowKey={selectedRowKey}
        />
      </Card>

      <TfsSrpYearRateModalComponent
        open={isModalOpen}
        record={selectedRow}
        onCancel={onCloseModal}
        onSave={onSaveModal}
        loading={modalLoading}
      />
    </>
  );
};
